import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.set";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { sonRoleAdd } from "@/api/auth/onlineUser";
import { Message } from "element-ui";
import { mapActions, mapState } from "vuex";
export default {
  props: {
    presentation: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      props: {
        multiple: true,
        showing: {
          type: Boolean,
          default: false
        }
      },
      entrance: [{
        label: "显示游戏",
        value: 1
      }, {
        label: "显示产品",
        value: 2
      }],
      dialogFormVisible: false,
      valuearray: [],
      form: {
        id: '',
        title: "",
        description: "",
        listorder: 100,
        is_show_home: "",
        status: 1,
        source_role: '',
        game_show_type: 1
      },
      upForm: {},
      options: [],
      rules: {
        title: [{
          required: true,
          message: "请输入角色名称",
          trigger: "blur"
        }],
        description: [{
          required: true,
          message: "请输入角色描述",
          trigger: "blur"
        }],
        status: [{
          required: true,
          message: "请选择状态",
          trigger: "change"
        }],
        is_show_home: [{
          required: true,
          message: "请选择",
          trigger: "change"
        }]
      }
    };
  },
  mounted: function mounted() {},
  created: function created() {},
  computed: _objectSpread({}, mapState({
    userInfo: function userInfo(state) {
      return state.d2admin.user.info;
    }
  })),
  methods: _objectSpread(_objectSpread({}, mapActions("d2admin/user", ["queryAdd", "queryupRole", "upRole", "roleAdd"])), {}, {
    format: function format(data) {
      var _this = this;

      // 格式化数据格式
      var res = [];
      data.forEach(function (item) {
        var menu = {
          value: item.id,
          label: item.title
        };

        if (item.son && item.son.length > 0) {
          menu.children = _this.format(item.son);
        }

        res.push(menu);
      });
      return res;
    },
    forEach: function forEach(data) {
      var _this2 = this;

      // 格式化数据格式
      var res = [];
      data.forEach(function (item) {
        var menu = {
          value: item.id,
          label: item.title
        };

        if (item.son && item.son.length > 0) {
          menu.children = _this2.format(item.son);
        }

        res.push(menu);
      });
      return res;
    },
    flatten: function flatten(arr) {
      var _this3 = this;

      return arr.reduce(function (a, b) {
        return [].concat(Array.isArray(a) && a ? _this3.flatten(a) : a, Array.isArray(b) && b ? _this3.flatten(b) : b);
      }, []);
    },
    init: function init(id) {
      var _arguments = arguments,
          _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var type, query;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                type = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : false;
                _this4.dialogFormVisible = true;
                _context2.next = 4;
                return _this4.queryAdd();

              case 4:
                query = _context2.sent;
                _this4.options = _this4.format(query);

                if (!id) {
                  _context2.next = 8;
                  break;
                }

                return _context2.delegateYield( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  var queryupUser, arr, arrT, _loop, i, list;

                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return _this4.queryupRole({
                            id: id
                          });

                        case 2:
                          queryupUser = _context.sent;
                          _this4.form = _objectSpread({}, queryupUser.role_info);
                          _this4.upForm = _objectSpread({}, queryupUser);
                          arr = [];
                          arrT = [];

                          _loop = function _loop(i) {
                            var myarr = _this4.deepFind(_this4.options, function (item, index, level) {
                              return item.value === queryupUser.auth_me[i];
                            }, "children");

                            arr.push(myarr.map(function (_) {
                              return _.value;
                            }));
                          };

                          for (i = 0; i < queryupUser.auth_me.length; i++) {
                            _loop(i);
                          }

                          _this4.valuearray = arr;
                          list = [];

                          _this4.options.forEach(function (i) {
                            arr.forEach(function (j) {
                              var indexs = list.findIndex(function (k) {
                                return k.value == j[0];
                              });

                              if (i.value == j[0] && indexs == -1) {
                                list.push({
                                  value: i.value,
                                  name: i.label,
                                  list: []
                                });
                              } else if (i.value == j[0]) {
                                i.children.forEach(function (d) {
                                  if (d.value == j[1]) {
                                    list[indexs].list.push(d.label);
                                  }
                                });
                              }
                            });
                          });

                          list.map(function (i) {
                            i.list = i.list.toString();
                          });
                          console.log(list);

                        case 14:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })(), "t0", 8);

              case 8:
                if (type) {
                  _this4.form.id = '';
                  _this4.form.source_role = id;
                }

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    dataReset: function dataReset() {
      this.valuearray = [];
      this.form = {
        id: '',
        title: "",
        description: "",
        listorder: 100,
        is_show_home: '',
        source_role: '',
        status: 1,
        game_show_type: 1
      };
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.dataReset();
      this.$emit("changeShow", false);
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var arr, reqFn;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                arr = Array.from(new Set(_this5.valuearray));
                reqFn = _this5.form.id ? _this5.upRole : sonRoleAdd;
                _this5.form.permission_group = arr.toString(), _this5.form.game_show_type = 1;
                reqFn(_this5.form).then( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(res) {
                    var arrList, isUpRolor, isUpForm, arr1, arr2;
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if (!(res.status == 200)) {
                              _context3.next = 24;
                              break;
                            }

                            if (!(res.data == 1)) {
                              _context3.next = 21;
                              break;
                            }

                            if (!(_this5.form.status == 0)) {
                              _context3.next = 5;
                              break;
                            }

                            _this5.$store.dispatch('d2admin/account/logout', {
                              confirm: false
                            });

                            return _context3.abrupt("return");

                          case 5:
                            arrList = _this5.form.permission_group.split(',');
                            arrList = Array.from(new Set(arrList));
                            isUpRolor = false;

                            try {
                              isUpForm = _this5.upForm.auth_me.length > arrList.length ? true : false;
                              arr1 = isUpForm ? _this5.upForm.auth_me : arrList;
                              arr2 = isUpForm ? arrList : _this5.upForm.auth_me;
                              arr1.forEach(function (i) {
                                if (arr2.findIndex(function (k) {
                                  return k == i;
                                }) == -1) {
                                  isUpRolor = true;
                                  throw Error();
                                }
                              });
                            } catch (e) {}

                            _context3.next = 11;
                            return _this5.$store.dispatch('d2admin/user/setHomeShow', _this5.form.is_show_home);

                          case 11:
                            if (!(_this5.form.game_show_type !== _this5.upForm.role_info.game_show_type)) {
                              _context3.next = 17;
                              break;
                            }

                            _context3.next = 14;
                            return _this5.$store.dispatch('d2admin/user/gameShowType', _this5.form.game_show_type);

                          case 14:
                            _context3.next = 16;
                            return _this5.$store.dispatch('d2admin/serchSelect/clearData', 1);

                          case 16:
                            _this5.$router.replace('/');

                          case 17:
                            _context3.next = 19;
                            return _this5.$store.dispatch('d2admin/serchSelect/setGame');

                          case 19:
                            if (isUpRolor && _this5.form.game_show_type !== _this5.upForm.role_info.game_show_type) {
                              _this5.$store.dispatch('d2admin/db/set', {
                                dbName: 'sys',
                                path: 'menu.Settings',
                                value: false,
                                user: true
                              }, {
                                root: true
                              });
                            }

                            if (isUpRolor) {
                              _this5.$store.dispatch("d2admin/account/ResetRoute");
                            }

                          case 21:
                            Message.success('设置成功');

                            _this5.$emit("refreshDataList");

                            _this5.resetForm("ruleForm");

                          case 24:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    deepFind: function deepFind(arr, condition, children) {
      // 即将返回的数组
      var main = []; // 用try方案方便直接中止所有递归的程序

      try {
        // 开始轮询
        (function poll(arr, level) {
          // 如果传入非数组
          if (!Array.isArray(arr)) return; // 遍历数组

          for (var i = 0; i < arr.length; i++) {
            // 获取当前项
            var item = arr[i]; // 先占位预设值

            main[level] = item; // 检验是否已经找到了

            var isFind = condition && condition(item, i, level) || false; // 如果已经找到了

            if (isFind) {
              // 直接抛出错误中断所有轮询
              throw Error; // 如果存在children，那么深入递归
            } else if (children && item[children] && item[children].length) {
              poll(item[children], level + 1); // 如果是最后一个且没有找到值，那么通过修改数组长度来删除当前项
            } else if (i === arr.length - 1) {
              // 删除占位预设值
              main.length = main.length - 1;
            }
          }
        })(arr, 0); // 使用try/catch是为了中止所有轮询中的任务

      } catch (err) {} // 返回最终数组


      return main;
    }
  })
};